module.exports = __webpack_public_path__ + "img/menu-hair-6.d2b51d0a.webp";